import script from "./hallbox.vue?vue&type=script&setup=true&lang=js"
export * from "./hallbox.vue?vue&type=script&setup=true&lang=js"

import "./hallbox.vue?vue&type=style&index=0&id=ec20af16&scoped=true&lang=css"

import exportComponent from "C:\\vue2023\\cmsmap2023\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec20af16"]])

export default __exports__